<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter">About the Author</h1>
<p class="extract"><span class="small"><strong>HELEN BROOKS</strong></span> lives in Northamptonshire, and is married with three children and three beautiful grandchildren. As she is a committed Christian, busy housewife, mother and grandma, her spare time is at a premium, but her hobbies include reading, swimming and gardening, and walks with her husband and their two Irish terriers. Her long-cherished aspiration to write became a reality when she put pen to paper on reaching the age of forty and sent the result off to Mills &amp; Boon.</p>
<p class="extract"><strong>Recent titles by the same author:</strong><br/></p>
<p class="nonindent">THE BEAUTIFUL WIDOW<br/>SNOWBOUND SEDUCTION<br/>SWEET SURRENDER WITH THE MILLIONAIRE<br/>THE MILLIONAIRE’S CHRISTMAS WIFE<br/>THE BOSS’S INEXPERIENCED SECRETARY</p>
<p class="center"><strong>Did you know these are also available as eBooks?<br/>Visit www.Harlequin.com</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781460346471_epub_ata_r1.vue?3dd614c4